import { ConsumptionFinancialInfoModel } from '@logz-pkg/models';
import { ICrudApiService } from '../../utilities/types';
import { CrudApiService } from '../../utilities/crud.api.service';

class FinancialAccountInfoApiService implements ICrudApiService<ConsumptionFinancialInfoModel> {
  apiService = new CrudApiService<ConsumptionFinancialInfoModel>();

  urls = {
    financialInfo: (accountId: number) => `/consumption/financial-info/${accountId}`,
  };

  financialInfo = (accountId: number) => {
    return this.apiService.get(this.urls.financialInfo(accountId));
  };
}

export const financialAccountInfoApiService = new FinancialAccountInfoApiService();
